import React from 'react';
import classnames from 'classnames';

import LoadingSrc from 'images/loading.svg';

import styles from './index.css';

const Loading = ({
	active,
}) => (
	<div className={classnames(styles.loading, {
		[styles.show]: active,
	})}
	>
		<img src={LoadingSrc} alt="" />
	</div>
);

export default Loading;



// WEBPACK FOOTER //
// ./src/components/molecules/Loading/index.js